import { render } from "./Edit-2.vue?vue&type=template&id=6c57e3c2&scoped=true"
import script from "./Edit-2.vue?vue&type=script&lang=js"
export * from "./Edit-2.vue?vue&type=script&lang=js"

import "./Edit-2.vue?vue&type=style&index=0&id=6c57e3c2&scoped=true&lang=css"
import "./Edit-2.vue?vue&type=style&index=1&id=6c57e3c2&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c57e3c2"]])

export default __exports__